import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { ISystemData } from "../../../types/resource";

interface SystemFilterDropdownProps {
  allSystemData: ISystemData[];
  isSystemDataLoading: boolean;
  selectedSystemId: string | number | null;
  onSystemChange: (event: any, value: any) => void;
  className?: string;
  placeholder?: string;
  label?: string;
  includeSystemId?: boolean; // ✅ NEW: Controls whether to include system ID in display
}

const SystemFilterDropdown: React.FC<SystemFilterDropdownProps> = ({
  allSystemData,
  isSystemDataLoading,
  selectedSystemId,
  onSystemChange,
  className = "form-control-autocomplete",
  placeholder = "Select system",
  label = "System Filter",
  includeSystemId = false, // ✅ NEW: Default to false to match established pattern
}) => {
  const selectedSystem =
    allSystemData?.find((system: any) => system.id === selectedSystemId) ||
    null;

  return (
    <>
      <label className="label-text line-height16">{label}</label>
      <Autocomplete
        fullWidth
        options={allSystemData || []}
        getOptionLabel={(option: any) => {
          return includeSystemId
            ? `(${option?.id}) ${option?.value}` || ""
            : option?.value || "";
        }}
        value={selectedSystem}
        onChange={onSystemChange}
        loading={isSystemDataLoading}
        className={className}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: params.InputProps.endAdornment,
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {includeSystemId
              ? `(${option?.id}) ${option?.value}`
              : option?.value}
          </li>
        )}
        isOptionEqualToValue={(option: any, value: any) =>
          option.id === value.id
        }
        loadingText="Loading systems..."
      />
    </>
  );
};

export default SystemFilterDropdown;
